import * as React from 'react';
import { useState } from 'react';
import { TransProps, useTranslation } from 'react-i18next';
import { useMediaQuery } from 'react-responsive';

import { ArtworkTableTheme, Breakpoint } from '../../enums';
import { UseState } from '../../types';

import {
  Container,
  Description,
  DescriptionContainer,
  LeftSection,
  LinkButton,
  RightSection,
  StyledCircleBadges,
  StyledArtworkTable,
  StyledInformationBox,
  Title,
  ImagesContainer,
  ImageElement
} from './artworkDescription.styled';
import { ArtworkDescriptionProps } from './artworkDescription.types';

export const ArtworkDescription: React.FC<ArtworkDescriptionProps> = (props: ArtworkDescriptionProps): JSX.Element => {
  const {
    className,
    title,
    informationBoxDetails,
    description,
    badges,
    withReadMore,
    attributes,
    images,
    hideImagesOnError
  }: ArtworkDescriptionProps = props;
  const { t }: TransProps<never> = useTranslation();
  const [isDescriptionExpanded, setIsDescriptionExpanded]: UseState<boolean> = useState<boolean>(false);
  const isSmallMobile: boolean = useMediaQuery({ query: Breakpoint.SmallMobile });
  const filteredImages: string[] = images?.filter(Boolean) ?? [];

  return (
    <Container className={className}>
      <LeftSection>
        <Title>{title}</Title>
      </LeftSection>
      <RightSection>
        {informationBoxDetails && (
          <StyledInformationBox informationDetails={informationBoxDetails} />
        )}
        {description && (
          <DescriptionContainer>
            <Description 
              text={(!isDescriptionExpanded && withReadMore && description.length > 300) ? `${description.slice(0, 300)}...` : description} 
            />
            {(withReadMore && description.length > 300 && !images) && (
              <LinkButton onClick={(): void => setIsDescriptionExpanded(!isDescriptionExpanded)}>
                {!isDescriptionExpanded ? t('onarte.common.readMore') : t('onarte.common.readLess')}
              </LinkButton>
            )}
            {!!filteredImages.length && (
              <ImagesContainer>
                {filteredImages.map((image: string, key: number): JSX.Element => (
                  <ImageElement
                    src={image}
                    alt={`${title}-${key}`}
                    hideOnError={hideImagesOnError}
                    key={`${title}-${key}`}
                  />
                ))}
              </ImagesContainer>
            )}
          </DescriptionContainer>
        )}
        {!!badges?.length && <StyledCircleBadges badges={badges} />}
        {!!attributes?.length && (
          <StyledArtworkTable
            attributes={attributes}
            artworkTableTheme={isSmallMobile ? ArtworkTableTheme.Vertical : ArtworkTableTheme.Horizontal}
          />
        )}
      </RightSection>
    </Container>
  );
};
